import { render, staticRenderFns } from "./SlotFiltersComponent.vue?vue&type=template&id=c2d2256e"
import script from "./SlotFiltersComponent.vue?vue&type=script&lang=js"
export * from "./SlotFiltersComponent.vue?vue&type=script&lang=js"
import style0 from "./SlotFiltersComponent.vue?vue&type=style&index=0&id=c2d2256e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports